import React from "react";

const ProgressBar = ({ percent }) => (
  <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
    <div
      className="bg-orange-500 h-2 rounded-full"
      style={{ width: `${percent}%` }}
    ></div>
  </div>
);

export default ProgressBar;
